<h1 class="c11n-text-xl-headline c11n-space-stack-2x">{{ content?.heading }}</h1>
<c11n-banner
    role="alert"
    class="section-width c11n-space-stack-3x"
    [size]="'small'"
    [variant]="'error'"
    [hasCloseControl]="false"
    *ngIf="isTherePendingRequest"
    data-cy="pending-request-banner">
    <div
        class="c11n-text-md--crop">
        <div>{{ content?.errPendingAccessRequest.heading}}</div>
        <div>{{ removeHTMLtags(content?.errPendingAccessRequest.text1) }}</div>
    </div>
</c11n-banner>
<form [formGroup]="personalInfoForm" class="form col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8">
    <fieldset>
        <legend class="c11n-space-stack-6x">
            {{ removeHTMLtags(content?.body) }}
        </legend>
        <div class="c11n-space-stack-4x">
            <label c11n-label [for]="firstNameControlName" size="medium">{{
                    content?.frmfFirstName.labelText
                }}</label>
            <c11n-input
                size="medium"
                [hasError]="firstNameFormControl.invalid && firstNameFormControl.touched">
                <input
                    c11nInput
                    type="text"
                    id="firstName"
                    name="firstName"
                    aria-describedby="firstname-description"
                    class="c11n-input__input"
                    [formControlName]="firstNameControlName"/>
            </c11n-input>
            <c11n-hint-error
                [hasError]="
                        firstNameFormControl.hasError('required') && firstNameFormControl.touched
                    "
                [errorText]="
                        content?.frmfFirstName.errFirstNameRequired
                    "
                hintErrorId="firstname-description"
                size="medium"
            ></c11n-hint-error>
            <c11n-hint-error
                [hasError]="
                        firstNameFormControl.hasError('pattern') && firstNameFormControl.touched
                    "
                [errorText]="
                        content?.frmfFirstName.errNameValidCharacters
                    "
                hintErrorId="firstname-description"
                size="medium"
            ></c11n-hint-error>
        </div>

        <div class="c11n-space-stack-4x">
            <label c11n-label [for]="lastNameControlName" size="medium">{{
                    content?.frmfLastName.labelText
                }}</label>
            <c11n-input
                size="medium"
                [hasError]="lastNameFormControl.invalid && lastNameFormControl.touched">
                <input
                    c11nInput
                    type="text"
                    id="lastName"
                    name="lastName"
                    aria-describedby="lastname-description"
                    class="c11n-input__input"
                    [formControlName]="lastNameControlName"/>
            </c11n-input>
            <c11n-hint-error
                [hasError]="
                        lastNameFormControl.hasError('required') && lastNameFormControl.touched
                    "
                [errorText]="content?.frmfLastName.errLastNameRequired"
                hintErrorId="lastname-description"
                size="medium"
            ></c11n-hint-error>
            <c11n-hint-error
                [hasError]="
                        lastNameFormControl.hasError('pattern') && lastNameFormControl.touched
                    "
                [errorText]="content?.frmfLastName.errNameValidCharacters"
                hintErrorId="lastname-description"
                size="medium"
            ></c11n-hint-error>
        </div>

        <div class="c11n-space-stack-4x">
            <label c11n-label [for]="emailControlName" size="medium">{{
                    content?.frmfEmailAddress.labelText
                }}</label>
            <c11n-input
                size="medium"
                [hasError]="emailFormControl.invalid && emailFormControl.touched">
                <input
                    c11nInput
                    type="email"
                    inputmode="email"
                    id="email"
                    name="email"
                    aria-describedby="email-description"
                    class="c11n-input__input"
                    [formControlName]="emailControlName"
                    (blur)="trackFormattingErrorOnEmailField()"/>
            </c11n-input>
            <c11n-hint-error
                [hasError]="emailFormControl.touched && emailFormControl.invalid"
                [errorText]="getEmailAddressErrorMessage"
                hintErrorId="email-description"
                size="medium"
            ></c11n-hint-error>
        </div>

        <div class="c11n-space-stack-4x col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 col-xxl-8">
            <label c11n-label [for]="phoneNumberControlName" size="medium">{{
                    content?.frmfPhoneNumber.labelText
                }}</label>
            <c11n-input
                size="medium"
                [hasError]="phoneNumberFormControl.invalid && phoneNumberFormControl.touched">
                <input
                    c11nInput
                    type="tel"
                    inputmode="tel"
                    id="phoneNumber"
                    name="phoneNumber"
                    aria-describedby="phonenumber-description"
                    class="c11n-input__input"
                    [imask]="InputMask.PHONE"
                    [formControlName]="phoneNumberControlName"
                    (blur)="trackFormattingErrorOnPhoneNumberField()"/>
            </c11n-input>
            <c11n-hint-error
                [hasError]="phoneNumberFormControl.touched && phoneNumberFormControl.invalid"
                [errorText]="getPhoneNumberErrorMessage"
                hintErrorId="phonenumber-description"
                size="medium"
            ></c11n-hint-error>
        </div>
    </fieldset>
</form>
